import { render, staticRenderFns } from "./UserDetailView.vue?vue&type=template&id=c6cfa7ec&scoped=true&"
import script from "./UserDetailView.vue?vue&type=script&lang=ts&"
export * from "./UserDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cfa7ec",
  null
  
)

export default component.exports